import Setting from "@/model/setting";
import { AxiosResponse } from "axios";
import api from "./api";

class SettingApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async view(): Promise<AxiosResponse> {
    return this.getHttp().get<Setting>(`/admin/settings`);
  }
  async store(data): Promise<AxiosResponse> {
    return this.getHttp().put<Setting>("/admin/settings/store", data);
  }

  async updateNews(data): Promise<AxiosResponse> {
    return this.getHttp().post<Setting>("/admin/settings/news", data);
  }

  async getNews(): Promise<AxiosResponse> {
    return this.getHttp().get<Setting>("/common/settings/news");
  }

  async getMaintenanceNotice(): Promise<AxiosResponse> {
    return this.getHttp().get<Setting>("/common/settings/maintenance-notice");
  }

  async updateMaintenance(data): Promise<AxiosResponse> {
    return this.getHttp().post<Setting>("/admin/settings/maintenance", data);
  }

  async storeCategories(data): Promise<AxiosResponse> {
    return this.getHttp().post<any>("/admin/settings/categories", data);
  }
  async checkIsDelete(data): Promise<any> {
    return await this.getHttp().post("/admin/check-categories", data);
  }
}
export default new SettingApi();
